import { render, staticRenderFns } from "./recommend_books.vue?vue&type=template&id=0942eace&scoped=true"
import script from "./recommend_books.vue?vue&type=script&lang=js"
export * from "./recommend_books.vue?vue&type=script&lang=js"
import style0 from "./recommend_books.vue?vue&type=style&index=0&id=0942eace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942eace",
  null
  
)

export default component.exports